import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Хүсэлтүүд")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Устгах хүсэлт")
const _hoisted_6 = { class: "card shadow" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Устгах хүсэлтүүд")
  ])
], -1)
const _hoisted_8 = {
  class: "card-body",
  style: {"padding":"20px 0 10px 0"}
}
const _hoisted_9 = { style: {"padding":"0 30px"} }
const _hoisted_10 = {
  style: {"margin-top":"10px"},
  align: "center"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Зөвшөөрөх ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Цуцлах ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Батлах ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Татгалзах ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_input_number, {
            class: "col-sm-1",
            modelValue: _ctx.pageSize,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageSize) = $event)),
            onChange: _ctx.handleChange,
            min: 1,
            max: 100,
            size: "mini"
          }, null, 8, ["modelValue", "onChange"]),
          _createVNode(_component_el_input, {
            "prefix-icon": "el-icon-search",
            modelValue: _ctx.customerSearch,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customerSearch) = $event)),
            size: "mini",
            placeholder: "Хайх утга аа оруулна уу...",
            style: {"float":"right","width":"35%"}
          }, null, 8, ["modelValue"])
        ]),
        true
          ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: 
            this.tableData
              .filter(
                data =>
                  !this.customerSearch ||
                  data.searchfield.includes(this.customerSearch.toLowerCase())
              )
              .slice(
                this.pageSize * this.page - this.pageSize,
                this.pageSize * this.page
              )
          ,
              style: {"width":"100%","margin-top":"20px"},
              border: "",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              size: "mini",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "№",
                  width: "60",
                  prop: "id"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Байгууллага",
                  prop: "orgcode",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Төрөл",
                  prop: "type",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Түлхүүр талбар",
                  prop: "keyvalue",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Үүсгэсэн",
                  prop: "createdby",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Үүсгэсэн огноо",
                  prop: "createddate",
                  formatter: _ctx.$filters.formatDateYMDHMS,
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Хянасан",
                  prop: "revisedby",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Хянасан огноо",
                  prop: "reviseddate",
                  formatter: _ctx.$filters.formatDateYMDHMS,
                  sortable: ""
                }, null, 8, ["formatter"]),
                (this.role.includes('ROLE_REQUEST_REVISE') && this.isu)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      label: "Зөвшөөрөх",
                      width: "130px"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button_group, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              size: "mini",
                              icon: "fas fa-check fs-6 text-light",
                              type: "success",
                              onClick: ($event: any) => (_ctx.sendOnce('revise', scope.row.id)),
                              round: ""
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              icon: "fa fa-times fs-6 text-light",
                              type: "danger",
                              onClick: ($event: any) => (_ctx.sendOnce('cancel', scope.row.id)),
                              round: ""
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (this.role.includes('ROLE_REQUEST_APPROVE') && this.isu)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 1,
                      label: "Батлах",
                      width: "130px"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button_group, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              size: "mini",
                              icon: "fas fa-check fs-6 text-light",
                              type: "success",
                              onClick: ($event: any) => (_ctx.sendOnce('approve', scope.row.id)),
                              round: ""
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              icon: "fa fa-times fs-6 text-light",
                              type: "danger",
                              onClick: ($event: any) => (_ctx.sendOnce('deny', scope.row.id)),
                              round: ""
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.loadingtable]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, [
            (this.role.includes('ROLE_REQUEST_REVISE') && this.isu)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  style: {"padding":"0 10px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          size: "mini",
                          type: "success",
                          plain: "",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendAll('reviseAll')))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          size: "mini",
                          type: "danger",
                          plain: "",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sendAll('cancelAll')))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (this.role.includes('ROLE_REQUEST_APPROVE') && this.isu)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 1,
                  style: {"padding-left":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          size: "mini",
                          type: "success",
                          plain: "",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendAll('approveAll')))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          size: "mini",
                          type: "danger",
                          plain: "",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sendAll('denyAll')))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_pagination, {
              layout: "total, prev, pager, next, jumper",
              onCurrentChange: _ctx.handleCurrentChange,
              "page-size": _ctx.pageSize,
              total: this.tableData.length
            }, null, 8, ["onCurrentChange", "page-size", "total"])
          ])
        ])
      ])
    ])
  ], 64))
}